<template>
  <div class="modal fade" id="success-modal" data-bs-backdrop="static" tabindex="-1" aria-labelledby="successModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header bg-success text-white">
          <h5 class="modal-title" id="successModalLabel">{{ title }}</h5>
          <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body text-center">
          <div class="mb-3">
            <i class="mdi mdi-check-circle-outline text-success" style="font-size: 4rem;"></i>
          </div>
          <h4 class="text-success text-white">{{ heading }}</h4>
          <p>{{ message }}</p>
        </div>
        <div class="modal-footer justify-content-center">
          <button type="button" class="btn btn-success px-4" data-bs-dismiss="modal">OK</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SuccessModal',
  props: {
    title: {
      type: String,
      default: 'Success'
    },
    heading: {
      type: String,
      default: 'Operation Successful!'
    },
    message: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped>
/* Make backdrop lighter - not too dark */
:deep(.modal-backdrop) {
  background-color: rgba(0, 0, 0, 0.2) !important; /* 20% opacity */
}

:deep(.modal-backdrop.show) {
  opacity: 1 !important;
}

.modal-content {
  box-shadow: 0 5px 15px rgba(0,0,0,0.2);
}

.btn-close-white {
  filter: invert(1) grayscale(100%) brightness(200%);
}
</style>